// extracted by mini-css-extract-plugin
export default {"BodyContainer":"_BodyContainer--uaCM7","BodyContainerText":"_BodyContainerText--v35Vb","WarningIcon":"_WarningIcon--JQSSh"};